
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		text: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		}
	},
	i18nEx: {
		componentPrefix: "components.bookkeeping"
	}
});
